<template>
  <div class="step">
    <div class="step__container">
      <h3 class="step__header">
        Registrerede oplysninger om
        {{ privateAdFlowProductTypeNames.nameSingularParticular }}
      </h3>
      <p class="step__text step__text--device-visibility-medium"></p>
    </div>
    <div class="step__container">
      <div class="step__box">
        <h2 class="step__title" v-if="vehicleData.registrationNumber">
          Reg. nummer {{ decodeHTMLEntities(vehicleData.registrationNumber) }}
        </h2>
        <dl class="step__list">
          <template v-for="data in tableData" :key="'template_' + data.key">
            <dt class="step__type" v-html="data.key"></dt>
            <dd class="step__definition" v-html="data.value"></dd>
          </template>
        </dl>
      </div>
    </div>
    <div class="step__container">
      <!-- 
        //TODO: Skal der være en side til 'Ofte stillede spørgsmål'? Og i så fald skal link måske rettes 
        
        :linkText="'Læs ofte stillede spørgsmål'"
        :linkHref="'/faq'"
        :linkTarget:"'_blank'"
        -->
      <FactBox
        :title="'Er oplysningerne ikke korrekte?'"
        :body="'Hvis din variant ikke findes på listen, kan du kontakte vores support.'"
        :hasImageQuestionMark="true"
        :showSupport="true"
      />
      <p class="step__section-header step__input--required">Farve</p>
      <div class="step__section">
        <div class="step__section-item step__section-item--full-width">
          <p
            class="error my-1"
            v-if="colorErrorMessage"
            ref="colorErrorContainer"
          >
            <span>{{ colorErrorMessage }}</span>
            <span class="error__attention"></span>
          </p>
          <PrivateAdSelect
            class="private-ad-select--no-search private-ad-select--inline"
            :type="'radio'"
            :search-type="'radio-vehicle-color'"
            :title="'Farve'"
            :items="colorListCopy"
            :event-bus="proxyBus"
            :isUpdate="isUpdate"
          ></PrivateAdSelect>
        </div>
      </div>

      <div v-if="!this.registrationDateStrInitial">
        <p class="step__section-header step__input--required">
          <span>1. Indregistrering</span>
        </p>
        <div class="step__section">
          <div class="step__section-item step__section-item--full-width">
            <p
              class="error my-1"
              v-if="registrationDateStrErrorMessage"
              ref="registrationDateErrorContainer"
            >
              <span>{{ registrationDateStrErrorMessage }}</span>
              <span class="error__attention"></span>
            </p>
            <div class="input-container">
              <input
                class="step__input error--input form-control"
                type="text"
                id="registrationDateInput"
                placeholder="Skriv 1. indregistreringsdato (ex. dd-mm-åååå) * "
                v-model="registrationDateStr"
                ref="datepick"
                autocomplete="off"
              />
              <label class="control-label" for="registrationDateInput">
                <span class="capitalize">
                  {{ privateAdFlowProductTypeNames.nameSingularParticular }}s
                </span>
                1. indregistreringsdato
              </label>
            </div>
          </div>
        </div>
      </div>
      <p class="step__section-header step__input--required">Forbrug</p>
      <div class="step__section">
        <div class="step__section-item step__section-item--consumption">
          <p
            class="error my-1"
            v-if="consumptionStrErrorMessage"
            ref="consumptionStrErrorContainer"
          >
            <span>{{ consumptionStrErrorMessage }}</span>
            <span class="error__attention"></span>
          </p>
          <div class="input-container">
            <input
              class="step__input error--input form-control"
              inputmode="decimal"
              title="Forbrug"
              type="text"
              id="consumptionInput"
              :placeholder="placeholderConsumptionInput"
              v-model="consumptionTempStr"
              @blur="
                handleNumberPresentation({
                  varName: 'consumptionStr',
                  varTempName: 'consumptionTempStr',
                  prepareForPresentation: true,
                  postfix: 'km/l',
                  separateBythousands: true,
                })
              "
              @focus="
                handleNumberPresentation({
                  varName: 'consumptionStr',
                  varTempName: 'consumptionTempStr',
                })
              "
            />
            <label class="control-label" for="consumptionInput">
              <span class="capitalize"
                >{{
                  privateAdFlowProductTypeNames.nameSingularParticular
                }}s</span
              >
              Forbrug (km/l)
            </label>
          </div>
        </div>
        <div class="step__section-item step__section-item--kilometers">
          <p
            class="error my-1"
            v-if="kilometersStrErrorMessage"
            ref="kilometersStrErrorContainer"
          >
            <span>{{ kilometersStrErrorMessage }}</span>
            <span class="error__attention"></span>
          </p>
          <div class="input-container">
            <input
              class="step__input error--input step__input--required form-control"
              inputmode="decimal"
              title="Km"
              type="text"
              id="kilometersInput"
              placeholder="Skriv kørte kilometer *"
              v-model="kilometersTempStr"
              @blur="
                handleNumberPresentation({
                  varName: 'kilometersStr',
                  varTempName: 'kilometersTempStr',
                  prepareForPresentation: true,
                  postfix: 'km',
                  separateBythousands: true,
                  isInteger: true,
                })
              "
              @focus="
                handleNumberPresentation({
                  varName: 'kilometersStr',
                  varTempName: 'kilometersTempStr',
                })
              "
            />
            <label class="control-label" for="kilometersInput">
              Antal kørte kilometer
            </label>
          </div>
        </div>
      </div>
    </div>
    <StepButtonPanel
      :event-bus="eventBus"
      :back-visible="backVisible"
      :next-visible="true"
      :next-enabled="true"
      :is-update="isUpdate"
      :validate-function="validate"
    ></StepButtonPanel>
  </div>
</template>
<script>
import { app } from '@/main'
import mitt from 'mitt'

import Pikaday from 'pikaday'
import { decodeHTMLEntities } from '@/functions'
import { scrollToView } from './StepsFunctions'
import FactBox from '@/components/FactBox/FactBox.vue'
import NumberPresentationFunctions from '@components/Shared/NumberPresentationFunctions.vue'
import StepButtonPanel from '../Components/StepButtonPanel/StepButtonPanel.vue'
import PrivateAdSelect from '../Components/PrivateAdSelect/PrivateAdSelect.vue'

export default {
  mixins: [NumberPresentationFunctions],
  components: {
    StepButtonPanel,
    FactBox,
    PrivateAdSelect,
  },
  props: {
    eventBus: { default: null, type: Object },
    colorList: { default: null, type: Array },
    registrationDateStrInitial: { default: false, type: Boolean },
    tableData: {
      default: () => {
        return []
      },
      type: Array,
    },
    vehicleData: {
      default: () => {
        return {}
      },
      type: Object,
    },
    errorCollection: {
      default: () => {
        return []
      },
      type: Array,
    },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
    isUpdate: { default: false, type: Boolean },
    inProgress: { default: false, type: Boolean },
  },
  data() {
    return {
      proxyBus: mitt(),
      isValid: true,
      registrationDateStr: '',
      registrationDateStrErrorMessage: '',
      registrationDateStrPropertyTypeId: 18,
      dateFormat: 'DD-MM-YYYY',
      maxDate: new Date(),
      yearRange: [1900, 2050],
      options: {
        firstDay: 1,
        defaultDate: null,
      },
      consumptionStr: '',
      consumptionTempStr: '',
      consumptionStrErrorMessage: '',
      kilometersStr: '',
      kilometersTempStr: '',
      kilometersStrErrorMessage: '',
      colorListCopy: [],
      colorId: 0,
      colorErrorMessage: '',
      placeholderConsumptionInput: `Skriv ${this.privateAdFlowProductTypeNames.nameSingularParticular}s forbrug (km/l)*`,
      mounted: false,
      backVisible: true,
      frontendErrorCollection: [],
    }
  },
  methods: {
    decodeHTMLEntities(val) {
      return decodeHTMLEntities(val)
    },
    validate() {
      this.frontendErrorCollection = []
      // Validerer i omvendt rækkefølge for at ramme
      let errorContainer = ''
      if (
        typeof this.kilometersStr === 'undefined' ||
        this.kilometersStr === null ||
        this.kilometersStr === ''
      ) {
        this.frontendErrorCollection.push({
          errorItem: this.vehicleData.kilometers.id,
          errorMessage: 'Angiv køretøjets kilometerstand',
        })
        this.kilometersStrErrorMessage = 'Angiv køretøjets kilometerstand'
        errorContainer = 'kilometersStrErrorContainer'
      }
      if (
        typeof this.consumptionStr === 'undefined' ||
        this.consumptionStr === null ||
        this.consumptionStr === ''
      ) {
        this.frontendErrorCollection.push({
          errorItem: this.vehicleData.consumption.id,
          errorMessage: 'Angiv køretøjets forbrug',
        })
        this.consumptionStrErrorMessage = 'Angiv køretøjets forbrug'
        errorContainer = 'consumptionsStrErrorContainer'
      }
      if (
        typeof this.registrationDateStr === 'undefined' ||
        this.registrationDateStr === null ||
        this.registrationDateStr === ''
      ) {
        this.frontendErrorCollection.push({
          errorItem: this.registrationDateStrPropertyTypeId.toString(),
          errorMessage: 'Angiv 1. indregistreringsdato',
        })
        this.registrationDateStrErrorMessage = 'Angiv 1. indregistreringsdato'
        errorContainer = 'registrationDateErrorContainer'
      }
      if (this.colorId === 0) {
        this.frontendErrorCollection.push({
          errorItem: this.vehicleData.color.id,
          errorMessage: 'Angiv farven på køretøjet',
        })
        this.colorErrorMessage = 'Angiv farven på køretøjet'
        errorContainer = 'colorErrorContainer'
      }

      if (this.frontendErrorCollection.length > 0) {
        setTimeout(() => {
          scrollToView(this.$refs[errorContainer].parentElement, 50)
        }, 50)

        return false
      }

      return true
    },
    toggle(overlayRef) {
      if (overlayRef.isOpen) {
        this.close()
      } else {
        this.open(overlayRef)
      }
    },
    open(overlayRef) {
      // setTimeout to defeat the race condition in history.back and history.pushState
      window.setTimeout(() => {
        app.history.push(() => {
          const scroll = window.scrollY
          overlayRef.isOpen = false
          // setTimeout to defeat the race condition in history.back and history.pushState
          window.setTimeout(() => {
            window.scrollTo(0, scroll)
          }, 5)
        }, overlayRef)
        overlayRef.isOpen = true
      }, 60)
    },
    close() {
      app.history.pop()
    },
    handleSelection(data) {
      this.colorId = Number(data.item.value)
      this.close()
    },
    emitData(keyValuePair) {
      //this.validate()
      if (!this.mounted) return
      this.eventBus.emit('property-set-callback', keyValuePair)
    },
    parse(datestring) {
      const parts = datestring.split('-')
      const day = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1
      const year = parseInt(parts[2], 10)
      return new Date(year, month, day)
    },
  },
  watch: {
    consumptionStr() {
      this.consumptionStrErrorMessage = ''
      const keyValuePair = {
        id: this.vehicleData.consumption.id,
        name: this.consumptionStr,
      }

      this.emitData(keyValuePair)
    },
    kilometersStr() {
      this.kilometersStrErrorMessage = ''
      const keyValuePair = {
        id: this.vehicleData.kilometers.id,
        name: this.kilometersStr,
      }

      this.emitData(keyValuePair)
    },
    registrationDateStr() {
      if (this.vehicleData.registrationNumber !== undefined) return // we can't set registration date if licensePlate is defined

      this.registrationDateStrErrorMessage = ''
      this.vehicleData.registrationDateFirst = this.registrationDateStr
      const keyValuePair = {
        id: this.registrationDateStrPropertyTypeId,
        name: this.registrationDateStr,
      }

      this.emitData(keyValuePair)
    },
    colorId() {
      this.colorErrorMessage = ''
      const keyValuePair = {
        id: this.vehicleData.color.id,
        name: this.colorId.toString(),
      }

      this.emitData(keyValuePair)
      this.eventBus.emit('set-color-callback', this.colorId)
    },
    errorCollection() {
      this.consumptionStrErrorMessage = ''
      this.kilometersStrErrorMessage = ''
      this.registrationDateStrErrorMessage = ''
      this.colorErrorMessage = ''

      this.errorCollection.forEach(item => {
        if (item.errorItem == this.vehicleData.color.id) {
          this.colorErrorMessage = item.errorMessage
        }
        if (item.errorItem == this.vehicleData.consumption.id) {
          this.consumptionStrErrorMessage = item.errorMessage
        }
        if (item.errorItem == this.vehicleData.kilometers.id) {
          this.kilometersStrErrorMessage = item.errorMessage
        }
        if (item.errorItem == this.registrationDateStrPropertyTypeId) {
          this.registrationDateStrErrorMessage = item.errorMessage
        }
      })
    },
  },
  created() {
    window.scrollTo(0, 0)
    if (this.vehicleData) {
      if (this.vehicleData.registrationDateFirst) {
        this.registrationDateStr = this.vehicleData.registrationDateFirst
      }
      if (this.vehicleData.consumption && this.vehicleData.consumption.name) {
        this.consumptionTempStr = this.vehicleData.consumption.name // Sætter temp værdien, da den egentlige værdi sættes i handleNumberPresentation funktionen
        this.handleNumberPresentation({
          varName: 'consumptionStr',
          varTempName: 'consumptionTempStr',
          prepareForPresentation: true,
          postfix: 'km/l',
          separateBythousands: true,
        })
      }
      if (this.vehicleData.kilometers && this.vehicleData.kilometers.name) {
        this.kilometersTempStr = this.vehicleData.kilometers.name // Sætter temp værdien, da den egentlige værdi sættes i handleNumberPresentation funktionen
        this.handleNumberPresentation({
          varName: 'kilometersStr',
          varTempName: 'kilometersTempStr',
          prepareForPresentation: true,
          postfix: 'km',
          separateBythousands: true,
          isInteger: true,
        })
      }
    }

    if (this.isUpdate) {
      this.colorId = parseInt(this.vehicleData.color.name)
      this.backVisible = false
    }

    if (
      this.registrationDateStr !== '' ||
      this.vehicleData.properties == undefined
    )
      return
    const itemList = this.vehicleData.properties.filter(vehicleDataProp => {
      return vehicleDataProp.propertyTypeId === 6
    })
    if (itemList.length > 0) {
      this.options.defaultDate = new Date(`${itemList[0].value}-01-01`)
    }
  },
  mounted() {
    if (this.$refs.datepick !== undefined) {
      const datePicker = new Pikaday({
        field: this.$refs.datepick,
        format: this.dateFormat,
        toString(date) {
          // you should do formatting based on the passed format,
          // but we will just return 'D/M/YYYY' for simplicity
          const day = date.getDate()
          const month = date.getMonth() + 1
          const year = date.getFullYear()
          return `${day}-${month}-${year}`
        },
        parse(dateString) {
          // dateString is the result of `toString` method
          const parts = dateString.split('-')
          const day = parseInt(parts[0], 10)
          const month = parseInt(parts[1], 10) - 1
          const year = parseInt(parts[2], 10)
          return new Date(year, month, day)
        },
        maxDate: this.maxDate,
        yearRange: this.yearRange,
        i18n: {
          previousMonth: 'Forrige måned',
          nextMonth: 'Næste måned',
          months: [
            'Januar',
            'Februar',
            'Marts',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'December',
          ],
          weekdays: [
            'Søndag',
            'Mandag',
            'Tirsdag',
            'Onsdag',
            'Torsdag',
            'Fredag',
            'Lørdag',
          ],
          weekdaysShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
        },
        ...this.options,
        ...(this.options.defaultDate =
          this.registrationDateStr != ''
            ? this.parse(this.registrationDateStr)
            : null),
        onSelect: () => {
          this.registrationDateStr = datePicker.toString()
          this.options.defaultDate = this.parse(this.registrationDateStr)
        },
      })
    }

    setTimeout(() => {
      this.mounted = true
    }, 200)

    this.colorListCopy = JSON.parse(JSON.stringify(this.colorList))
    this.proxyBus.on('private-ad-select-toggle', this.toggle)
    this.proxyBus.on('private-ad-select-close', this.close)
    this.proxyBus.on('private-ad-select-selection', this.handleSelection)

    this.eventBus.emit('stepLoaded', 2)
  },
}
</script>

<style lang="scss">
@import 'Step.scss';
@import 'Pikaday.css';
</style>
